import styled from 'styled-components';

import { minWidth } from '@calm-web/design-system';

export const Wrapper = styled.div`
	display: grid;
	grid-column-gap: 16px;
	grid-template-columns: repeat(2, minmax(0, 1fr));
	margin-bottom: 24px;

	${minWidth('tablet')} {
		grid-template-columns: repeat(3, minmax(0, 1fr));
		margin-bottom: 16px;
	}

	${minWidth('desktop')} {
		grid-column-gap: 24px;
		grid-template-columns: repeat(4, minmax(0, 1fr));
		margin-bottom: 24px;
	}

	${minWidth('desktopLarge')} {
		grid-column-gap: 36px;
		grid-template-columns: repeat(6, minmax(0, 1fr));
		margin-bottom: 36px;
	}
`;
